// extracted by mini-css-extract-plugin
export default {"root":"SignInDetail_root__VUZo0","body":"SignInDetail_body__++zKs"};